import { render } from "./A4Landscape.vue?vue&type=template&id=1f86777c&scoped=true"
const script = {}

import "./A4Landscape.vue?vue&type=style&index=0&id=1f86777c&scoped=true&lang=css"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f86777c"]])

export default __exports__